window.mcb = window.mcb || {};
window.mcb.links = window.mcb.links || {};
window.mcb.links.painter = (function () {
  const _logger = window.mcb.utilities.createLogger('links.painter', 'Link Painter');

  // Safely get main element
  let main;
  try {
    main = document.querySelector('main');
    if (!main) {
      _logger.error('Main element not found in document');
      return {}; // Return empty module if initialization fails
    }
  } catch (err) {
    _logger.error('Failed to query main element:', err);
    return {};
  }

  // Safely get current host
  let currentHost;
  try {
    currentHost = (new URL(window.location)).host;
  } catch (err) {
    _logger.error('Failed to parse window location:', window.location, err);
    currentHost = window.location.hostname || '';
  }

  let internalHosts = [];
  const linkToTopValues = ['#top', '#page-top'];

  const baseClass = 'mcb-link';
  const treatedClass = baseClass + '--treated';
  const subClassLocal = baseClass + '--local';
  const subClassGoToTop = baseClass + '--go-to-top';
  const subClassMail = baseClass + '--mail';
  const subClassDownload = baseClass + '--download';
  const subClassInternal = baseClass + '--internal';
  const subClassSemiInternal = baseClass + '--semi-internal';
  const subClassExternal = baseClass + '--external';
  const subClassGoBack = baseClass + '--go-back';

  const subClassSuppressExternalOpensInNewWindow = null; //baseClass + '--supress--external';  
  const initDelay = 50;
  const ignoreNonInlineElements = false;
  const wrapNonInlineElementsContens = 'span';
  const linkContentIsWrappedClass = baseClass + '--wrapped';

  const externalLinksAddRel = 'noopener';
  const externalLinksAddTarget = '_blank';

  const goBackWrappedLinksSelectorSelector = '.mcb-link--go-back-wrapper a';

  const exclutionsSelector = `.mcb-inline-documentaion a:not(.${baseClass}--exclude),.mcb-button`;
  let selector = `a:not(.${baseClass}):not(.${baseClass}--exclude):not(.mcb-link-collection-block--link)`; // Add exclusions here
  let excludingParents = []; // Expensive
  let timer = undefined;

  const parseClass = function (link) {
    try {
      const url = link.href.trim();
      if (typeof url !== "undefined" && url !== null && url.length > 0) {
        const linkUrl = new URL(link.href);
        if (linkUrl.protocol === 'mailto:') {
          _logger.trace('Link is mailto:', linkUrl);
          return subClassMail;
        }
        else if (linkUrl.protocol !== 'https:') {
          _logger.warn('Link has wrong protocol:', linkUrl);
          return null;
        }

        const isLocalLink = linkUrl.origin === window.location.origin;
        const isCurrentPage = isLocalLink && linkUrl.pathname === window.location.pathname;
        if (linkUrl.hash !== '' && isCurrentPage) {
          _logger.trace('Link is local with hash:', linkUrl);
          try {
            link.addEventListener('click', window.mcb.effects.helpers.scrollToHelper.scrollToClick);
          } catch (err) {
            _logger.error('Failed to add scroll event listener:', link, err);
          }

          if (linkToTopValues.includes(linkUrl.hash)) {
            _logger.trace('Link is local to top:', linkUrl.hash);

            return subClassGoToTop;
          }

          return subClassLocal;
        }
        else {
          const leaf = linkUrl.pathname.substring(linkUrl.pathname.lastIndexOf('/') + 1);
          if (leaf.indexOf('.') > 0) {
            const type = leaf.substring(leaf.lastIndexOf('.') + 1).toLowerCase();
            if (type !== "htm" && type !== "html" && type !== "asp" && type !== "aspx" && type !== "php") {
              _logger.trace('Link is local with file type:', linkUrl, type);
              if (type === "xsd") {
                link.setAttribute("download", "");
              }

              return subClassDownload;
            }
          }
        }

        if (linkUrl.origin === window.location.origin) {
          _logger.trace('Link is internal:', linkUrl);
          return subClassInternal;
        } else if (internalHosts.includes(linkUrl.host)) {
          _logger.trace('Link is semi-internal:', linkUrl);
          return subClassSemiInternal;
        } else {
          _logger.trace('Link is external:', linkUrl);
          try {
            if (externalLinksAddTarget !== null &&
              (subClassSuppressExternalOpensInNewWindow == null ||
                link.closest('.' + subClassSuppressExternalOpensInNewWindow) === null)) {
              link.target = externalLinksAddTarget;
            }

            if (externalLinksAddRel !== null) {
              link.rel = externalLinksAddRel;
            }
          } catch (err) {
            _logger.error('Error setting external link attributes:', link, err);
          }

          return subClassExternal;
        }
      }
    }
    catch (err) {
      _logger.error('Error parsing link class:', link, err);
    }

    return null;
  };

  const paint = function (link, sender = null) {
    if (!link || !(link instanceof HTMLElement)) {
      _logger.error('Invalid link element provided:', link);
      return;
    }

    if (sender !== null) {
      _logger.trace('Painting link from ' + sender, link);
    }

    try {
      // Add base class safely
      try {
        link.classList.add(baseClass);
      } catch (err) {
        _logger.error('Failed to add base class:', baseClass, err);
        return;
      }

      if (link.id !== null && link.id !== '' && link.innerText !== null && link.innerText.trim() === '') {
        try {
          link.classList.add(linkContentIsWrappedClass);
          return;
        } catch (err) {
          _logger.error('Failed to add wrapped class:', linkContentIsWrappedClass, err);
          return;
        }
      }

      // Check excluding parents
      for (let i = 0; i < excludingParents.length; i++) {
        try {
          if (link.closest(excludingParents[i]) !== null) {
            _logger.warn('Link Painter was blocked by Parent "' + excludingParents[i] + '" from ' + sender, link);
            return;
          }
        } catch (err) {
          _logger.error('Error checking parent exclusion:', excludingParents, i, err);
        }
      }

      let applyNewClassesTo = link;

      // Handle block level elements
      if (ignoreNonInlineElements || wrapNonInlineElementsContens !== null) {
        try {
          const styles = window.getComputedStyle(link);
          const linkIsBlockElement = styles.getPropertyValue('display') !== 'inline'; // Todo: This might be too naïve
          if (linkIsBlockElement) {
            if (ignoreNonInlineElements) {
              return;
            }

            if (wrapNonInlineElementsContens !== null) {
              _logger.trace('Wrapping Block Level link content from ' + sender, link);
              try {
                const wrapper = document.createElement(wrapNonInlineElementsContens);
                wrapper.append(...link.childNodes);
                link.classList.add(linkContentIsWrappedClass);
                link.append(wrapper);
                applyNewClassesTo = wrapper;
              } catch (err) {
                _logger.error('Failed to wrap block level element:', linkContentIsWrappedClass, err);
                return;
              }
            }
          }
        } catch (err) {
          _logger.error('Error processing block level element:', link, err);
        }
      }

      // URL processing
      if (!link.href) {
        _logger.warn('Link has no href attribute:', link);
        return;
      }

      const newClass = parseClass(link);

      // Apply final class
      if (newClass !== null) {
        try {
          applyNewClassesTo.classList.add(newClass);
          applyNewClassesTo.classList.add(treatedClass);
          _logger.trace('Painted link as "' + newClass + '"', link);
        } catch (err) {
          _logger.error('Failed to add final class:', link, newClass, err);
        }
      }
    } catch (err) {
      _logger.error('Fatal error in paint function:', link, err);
    }
  };

  const buttonBaseClass = 'mcb-button';
  const buttonClasses = [buttonBaseClass + '--primary', buttonBaseClass + '--secondary', buttonBaseClass + '--outlined'];
  const buttonSelector = buttonClasses.map(c => '.' + c).join(',');
  const rteContainers = '.mcb-media-spot--body,.mcb-webpart--rte';

  const normalizeButtonLinks = function (base) {
    try {
      base.querySelectorAll(rteContainers).forEach((container) => {
        container.querySelectorAll(buttonSelector).forEach((element) => {
          try {
            if (element.tagName === 'A') {
              // Already correct: a.mcb-button--primary — just ensure base class.
              // Adding an existing class is a no-op so this is safe to re-run.
              element.classList.add(buttonBaseClass);
              return;
            }

            // Non-anchor element carrying the button class. Only spans are
            // expected from RTE output; anything else we leave alone to avoid
            // mutating unrelated structures (which would also re-trigger the
            // MutationObserver on every pass).
            if (element.tagName !== 'SPAN') {
              return;
            }

            const parentLink = element.closest('a');
            const childLink = element.querySelector('a');

            if (parentLink) {
              // Fix: a > span.mcb-button--primary  →  a.mcb-button--primary (unwrap span)
              buttonClasses.forEach((cls) => {
                if (element.classList.contains(cls)) {
                  parentLink.classList.add(cls);
                }
              });
              parentLink.classList.add(buttonBaseClass);
              element.replaceWith(...element.childNodes);
              _logger.trace('Normalized button span inside link:', parentLink);
            } else if (childLink) {
              // Fix: span.mcb-button--primary > a  →  a.mcb-button--primary (unwrap span)
              buttonClasses.forEach((cls) => {
                if (element.classList.contains(cls)) {
                  childLink.classList.add(cls);
                }
              });
              childLink.classList.add(buttonBaseClass);
              element.replaceWith(childLink);
              _logger.trace('Normalized button span wrapping link:', childLink);
            }
          } catch (err) {
            _logger.error('Error normalizing button link:', element, err);
          }
        });
      });
    } catch (err) {
      _logger.error('Error in normalizeButtonLinks:', err);
    }
  };

  const applyPainterToBase = function (sender, base) {
    try {
      // Pre-step: normalize button classes from RTE output
      normalizeButtonLinks(base);

      // Handle exclusions
      try {
        base.querySelectorAll(exclutionsSelector).forEach((link) => {
          try {
            link.classList.remove.apply(link.classList, Array.from(link.classList).filter(v => v.startsWith(baseClass)));
            link.classList.add(baseClass + '--exclude');
          } catch (err) {
            _logger.error('Error processing exclusion for link:', link, err);
          }
        });
      } catch (err) {
        _logger.error('Error processing exclusions:', err);
      }

      // Handle go back wrapped links
      // Supports both: .mcb-link--go-back-wrapper > a  AND  a > .mcb-link--go-back-wrapper
      try {
        base.querySelectorAll(goBackWrappedLinksSelectorSelector).forEach((link) => {
          try {
            link.classList.add(baseClass);
            link.classList.add(subClassGoBack);
            link.classList.add(treatedClass);
          } catch (err) {
            _logger.error('Error processing go back case for link:', link, err);
          }
        });
        base.querySelectorAll('a:has(> .mcb-link--go-back-wrapper)').forEach((link) => {
          try {
            if (!link.classList.contains(subClassGoBack)) {
              link.classList.add(baseClass);
              link.classList.add(subClassGoBack);
              link.classList.add(treatedClass);
            }
          } catch (err) {
            _logger.error('Error processing inverted go back case for link:', link, err);
          }
        });
      } catch (err) {
        _logger.error('Error processing go back cases:', err);
      }

      // Paint links
      try {
        base.querySelectorAll(selector).forEach((link) => {
          paint(link, sender);
        });
      } catch (err) {
        _logger.error('Error querying links to paint:', selector, err);
      }
    } catch (err) {
      _logger.error('Fatal error in applyPainter:', err);
    }
  }

  const applyPainterToMain = function (sender) {
    applyPainterToBase(sender, main);
  }

  const applyPainterToFooter = function (sender) {
    document.querySelectorAll('footer .mcb-footer-columns').forEach((columns) => {
      applyPainterToBase(sender, columns);
    });
  }

  // Initialize observer with error handling
  let observer;
  try {
    observer = new MutationObserver(function (mutations) {
      if (mutations.length > 0) {
        if (timer !== undefined) {
          try {
            clearTimeout(timer);
          } catch (err) {
            _logger.error('Error clearing timer:', err);
          }
        }

        try {
          timer = setTimeout(function () {
            applyPainterToMain('mutation');
          }, 100);
        } catch (err) {
          _logger.error('Error setting mutation timer:', err);
        }
      }
    });
  } catch (err) {
    _logger.error('Failed to create MutationObserver:', err);
  }

  // Initialize internal hosts
  if (window.useInternalHostNames) {
    internalHosts = window.useInternalHostNames;
    _logger.trace('Link Painter configured with internal hosts', internalHosts);
  }
  else {
    try {
      document.querySelectorAll('.mcb-header--link--level-1 a').forEach((firstLevelLink) => {
        try {
          const host = new URL(firstLevelLink.href).host;
          if (host !== currentHost && !internalHosts.includes(host)) {
            internalHosts.push(host);
          }
        } catch (err) {
          _logger.error('Error processing internal host:', firstLevelLink.href, err);
        }
      });

      if (internalHosts.length > 0) {
        _logger.trace('Link Painter treating these hosts as Semi Internal', internalHosts);
      }
    } catch (err) {
      _logger.error('Error initializing internal hosts:', err);
    }
  }

  // Start observing
  if (observer) {
    try {
      observer.observe(main, { attributes: false, childList: true, characterData: false, subtree: true });
    } catch (err) {
      _logger.error('Failed to start observer:', err);
    }
  }

  // Initial paint
  try {
    setTimeout(applyPainterToMain, initDelay);
    setTimeout(applyPainterToFooter, initDelay);
  } catch (err) {
    _logger.error('Failed to set initial paint timer:', err);
  }

  return {
    applyPainter: function () {
      try {
        applyPainterToMain('manual');
      } catch (err) {
        _logger.error('Error in manual applyPainter:', err);
      }
    },
    addExlusionClass: function (exludeClass = null) {
      try {
        if (exludeClass === null || exludeClass.trim() === '') {
          _logger.trace('window.links.painter.addExlusionClass was called, but the exludeClass is invalid', exludeClass);
          return false;
        }

        const exclusion = ':not(.' + exludeClass.trim() + ')';
        if (selector.indexOf(exclusion) > 0) {
          _logger.trace('window.links.painter.addExlusionClass was called, but the exludeClass is already added', exludeClass, exclusion, selector);
          return false;
        }

        selector += exclusion;
        _logger.trace('window.links.painter.addExlusionClass added exclusion', exclusion, selector);
        return true;
      } catch (err) {
        _logger.error('Error in addExlusionClass:', exludeClass, err);
        return false;
      }
    }
  }
})();
